
(function(template){
    define('vue!app/views/vue/components/cartComponent/popupLoginComponent/componentPopUp',['Vue','vue!modeSelector/components/LoginComponent','vue!modeSelector/components/GroupMemberListComponent','vuex'],function(Vue,loginComponent,GroupMemberListComponent,vuex){
        return {
            template:template,
            components: {
                'login-component' : loginComponent,
                'group-member-list-component' : GroupMemberListComponent
            },
            data: function(){
                return {
                    showPopup: false,
                    showLoginComponent: false,
                    userLoggedIn: false
                }
            },
            methods: {
                handleKeyDown: function(e) {
                    var vm = this;
                    this.a11yKeyDown(e,
                    {
                        enter: function(){
                            e.target.click();
                        }
                    });
                },
                togglePopUp: function(){
                    this.showPopup = !this.showPopup;
                },
                hide: function(){
                    if(this.showPopup ==true) {
                        if(Object.keys(this.$store.state.users).length == 0){
                            if(this.desktopMode){
                            this.$store.commit('addGlobalMessage',{type: 'warn',message: this.localization.spaBooking.packageBooking.errors.noGuestSelected});
                            
                            $('.messages-container')[0].scrollIntoView({block:'center',behavior: "smooth"});
                            }
                            else{
                                this.$store.commit('SetmobileViewMessages',{key: 'fail',message: this.localization.spaBooking.packageBooking.errors.noGuestSelected})
                                window.scrollTo({top: 0,left: 0,behavior: 'smooth'})
                            }
                        }
                        this.showPopup = false;
                    };
                }
            },
            computed:  _.extend(vuex.mapState(['desktopMode','activeStep', 'loggedInUser']),{
                popupBodyHeader: function(){
                    return !this.userLoggedIn ? this.localization.spaBooking.packageBooking.login.ui.popUpHeaderWhenNotLoggedIn : this.localization.spaBooking.packageBooking.login.ui.popUpHeaderWhenLoggedIn;
                },
            }),
            watch: {
                showPopup: function(val){
                    if(!val) $('.component-popup .focus').focus();
                },
            },
            mounted: function(){
                if(app.data.CustomerGUID && app.data.CustomerId) this.userLoggedIn = true;
            },
        }
    })
})('<div v-if="activeStep == 0" class="component-popup" v-click-outside="hide" > <span class="side-cart-add-more-guest">{{localStrings.sideCart.addGuests}}</span> <i tabindex="0" class="fas fa-user-plus pointer focus" @keydown="handleKeyDown" @click="togglePopUp" ></i> <div class="popup-body" v-show="showPopup"> <!-- <i class="fas fa-sort-up fa-lg popup-arrow"></i> --> <div class="popup-body-header">{{popupBodyHeader}}</div> <login-component :fromApp="true" :userLoggedIn.sync="userLoggedIn" v-if="!loggedInUser" ></login-component> <group-member-list-component :fromApp="true" v-else :showPopup.sync = "showPopup" ></group-member-list-component> </div> </div>');
